import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// AuthContext provides authentication state and login/logout functions
// for the mock frontend, with role-based redirection.

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('authToken')); // Initialize token from localStorage
  const [isLoading, setIsLoading] = useState(true); // Add loading state
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('authUser');
    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
        // Optional: Verify token validity with a /auth/me endpoint call here
      } catch (error) {
        console.error("Error parsing stored user data:", error);
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        setToken(null);
        setUser(null);
      }
    }
    setIsLoading(false); // Finished loading initial auth state
  }, [token]); // Re-run if token changes (e.g., after login/logout)

  const login = (userData, authToken) => {
    localStorage.setItem('authToken', authToken);
    localStorage.setItem('authUser', JSON.stringify(userData));
    setToken(authToken);
    setUser(userData);

    // Use API role names for redirection
    switch (userData.role) {
      case 'ADMIN':
        navigate('/users');
        break;
      case 'SHIPOWNER':
        navigate('/vessels');
        break;
      case 'SUPPLIER':
        // Suppliers first view: vessels they have permissions for
        navigate('/supplier-vessels');
        break;
      case 'VERIFIER':
        // Verifiers first view: vessels they have permissions for
        navigate('/verifier-vessels');
        break;
      default:
        navigate('/'); // Fallback
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    setToken(null);
    setUser(null);
    navigate('/login');
  };

  // Provide loading state so App doesn't render routes prematurely
  const value = { user, token, login, logout, isLoading };

  // Don't render children until loading is complete to prevent flicker
  if (isLoading) {
      return null; // Or a loading spinner component
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
